module.exports = require("./kde-TZ");